<template>
  <div>
    <PageAllow controller="DeliveryPoints" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet v-show="!currentItemMode" class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="$t('DeliveryPoint.keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">
                  {{ $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down" }}
                </v-icon>
              </v-btn>

              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('DeliveryPoints', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("DeliveryPoint.ObjectName")]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('DeliveryPoints', 'relations')"
                small
                color="primary"
                class="ms-1"
                href="/#/stocks/delivery-point/relations"
              >
                {{ $t("DeliveryPoint.relationBtn") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 检索条件 -->
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="deliveryPoints"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.address="{ item }">
              <AddressText
                :masterItem="item"
                :detailAddress="item.address"
              />
            </template>
            <template v-slot:item.stock_count="{ item }">
              <a
                v-if="item.stock_count > 0"
                class="text-no-wrap"
                @click.stop="
                  bindStocksDialog = true;
                  deliveryPointId = item ? item.id : ''
                "
              >
                {{ item.stock_count }}
              </a>
              <span v-else>
                 {{ item.stock_count }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                  >fa-file-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.viewInfo", [$t("DeliveryPoint.ObjectName")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('DeliveryPoints', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                  >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.editInfo", [$t("DeliveryPoint.ObjectName")]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('DeliveryPoints', 'delete') && item.actions.delete"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      deleteItem = item;
                      deleteDialog = true;
                    "
                  >
                    fa-trash-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.deleteInfo", [$t("DeliveryPoint.ObjectName")]) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <DeliveryPointDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getDeliveryPointFromAPI()"
    />
    <DialogBindStocks
      v-model="bindStocksDialog"
      :deliveryPointId="deliveryPointId"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('DeliveryPoint.ObjectName')"
      @confirm="
        deleteDeliveryPoint(deleteItem);
        deleteDialog = false;
      "
    />
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import { mapState } from "vuex";
import DeliveryPoints from "@/api/delivery_points";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import DeliveryPointDetail from "./plugins/Detail";
// import KingdeeWorker from "@/api/kingdee_worker";
// import snackbar from "@/plugins/snackbar";
import DialogDelete from "@/components/plugins/DialogDelete";
import DialogBindStocks from "./plugins/DialogBindStocks";
import AddressText from "@/components/plugins/AddressText";

const defaultOptions = {
  keyword: "",
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    DeliveryPointDetail,
    DialogDelete,
    DialogBindStocks,
    AddressText,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.stocks"),
        disabled: false,
        href: "/stocks",
      },
      {
        text: i18n.t("DeliveryPoint.title"),
        disabled: true,
        href: "/stocks/delivery-point",
      },
    ],

    headers: () => [
      {
        text: i18n.t("DeliveryPoint.Fields.code"),
        align: "center",
        sortable: false,
        value: "code",
      },
      {
        text: i18n.t("DeliveryPoint.Fields.name"),
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("DeliveryPoint.Fields.manager"),
        align: "center",
        sortable: false,
        value: "manager",
      },
      {
        text: i18n.t("DeliveryPoint.Fields.tel"),
        align: "center",
        sortable: false,
        value: "tel",
      },
      {
        text: i18n.t("DeliveryPoint.Fields.address"),
        align: "center",
        sortable: false,
        value: "address",
      },
      {
        text: i18n.t("DeliveryPoint.Fields.stock_count"),
        align: "center",
        sortable: false,
        value: "stock_count",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        class: "text-no-wrap",
        value: "actions",
        width: 200,
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("deliveryPoint", []).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();
      }.bind(this)
    );
  },

  data: () => ({
    deliveryPoints: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("deliveryPoint-options")
        ? sessionStorage.getItem("deliveryPoint-options")
        : JSON.stringify(defaultOptions)
    ),
    keyword: "",
    currentItemMode: null,
    currentItem: null,
    deleteDialog: false,
    bindStocksDialog: false,
    deleteItem: null,
    deliveryPointId: "",
  }),

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    getDeliveryPointFromAPI() {
      DeliveryPoints.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deliveryPoints = response.data.delivery_points;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    deleteDeliveryPoint(data) {
      if (data) {
        DeliveryPoints.del(data.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("DeliveryPoint.Messages.deleteMsg"));
              this.deleteItem = null;
              this.getDeliveryPointFromAPI()
            }
          }.bind(this)
        )
      }
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem)
          this.$router.replace("/stocks/delivery-point?id=" + this.currentItem.id);
        else this.$router.replace("/stocks/delivery-point");
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getDeliveryPointFromAPI();
        sessionStorage.setItem("deliveryPoint-options", JSON.stringify(this.options));
      },
    },
    bindStocksDialog:{
      handler() {
        if (!this.bindStocksDialog) {
          this.deliveryPointId = ""
        }
      }
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>